export default {
	isDirty: function () {
		return false;
	},

	validate: function () {
		return true;
	},

	clearDirty: function () {
		
	},

	clear: function () {
		this.set();
	},

	flash: function () {
		
	},

	set: function () {
		
	},

	get: function () {
		return null;
	}
};



// WEBPACK FOOTER //
// ./src/widgets/fieldWidget.def.js